import styled from 'styled-components';
import { colours, fontSizes } from "../../constants/css";
var PageHeaderMobile = styled.div.withConfig({
  displayName: "PageHeaderMobile",
  componentId: "sc-adsib5-0"
})(["margin:0;height:4rem;padding-left:1rem;border-bottom:0.5px solid ", ";> h1{line-height:4rem;margin:0;font-size:", ";}"], colours.qantasBorderLightGrey, fontSizes.xl1);
export default PageHeaderMobile;